import React, { useState } from 'react'
import MaterialTable from 'material-table'
import { Edit, Delete, Visibility } from '@material-ui/icons'
import { minPermisos } from '../../../../constants/permits'
import { useStyles, tableIcons } from '../styles'

const TableType4 = (props) => {
  const {
    onOpenDetails,
    columns,
    loading,
    onDelete,
    minValue,
    openForm,
    onSelectRow,
    pageSize = 10,
    dataTable = [],
    onNotification,
    showButton = false,
    isSelection = false,
    hiddenDelete,
    hiddenEdit,
    title = 'Filtre y edite',
  } = props
  const classes = useStyles()
  const [selected, setSelectedRow] = useState(null)
  let data = []

  if (dataTable) {
    data = dataTable
  }

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: true,
            },
            body: {
              emptyDataSourceMessage: ' No hay datos en la tabla',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          //icons={tableIcons}
          isLoading={loading}
          title={
            showButton && minValue >= minPermisos.ACTUALIZAR ? (
              <NotificationMail onNotification={onNotification} />
            ) : (
              title
            )
          }
          columns={columns}
          data={data}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            pageSize,
            loadingType: 'linear',
            actionsColumnIndex: -1,
            exportButton: false,
            draggable: false,
            filtering: false,
            search: true,
            padding: 'dense',
            exportAllData: true,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            addRowPosition: 'first',
            exportFileName: 'Exportación Lucia Analitics',
            headerStyle: {
              backgroundColor: '#1B1B1B',
              color: '#FFF',
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selected === rowData.tableData.id ? '#EEE' : '#FFF',
              fontSize: 14,
            }),
            selection: isSelection,
            selectionProps: (rowData) => ({
              // disabled: rowData.id !== rowData.id,
              color: rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
            }),
          }}
          onSelectionChange={(rowData, selectedRow) => onSelectRow(selectedRow)}

          actions={[

            {
              icon: () => <Visibility style={{color: 'gray'}}/>,
              tooltip: 'Detalle',
              onClick: (event, rowData) => onOpenDetails(rowData),

            },
            { 
              color: "yellow",
              icon: () => <Edit style={{color:'#ff9800'}}/>,
              tooltip: 'Editar',
              onClick: (event, rowData) => openForm('edit', rowData),
              hidden: hiddenEdit,
            },
            {
              icon: () => <Delete style={{color: 'red'}} /> ,
              tooltip: 'Eliminar',
              onClick: (event, rowData) => onDelete(rowData),
              hidden: hiddenDelete,
            },
          ]}
        />
      </div>
    </div>
  )
}

export default TableType4